module.exports = __webpack_public_path__ + "static/media/194.acd7130d.jpg";